import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileSearchTab.scss';

import searchIcon from '../Header/img/search.png';
import searchIconActive from '../Header/img/search-active.png';

const MobileSearchTab = () => {
  const location = useLocation();

  const isSearchActive = /^\/search(\/|$)/.test(location.pathname);
  const isChatDetails = /^\/messages\/[^/]+\/?$/.test(location.pathname);

  if (isChatDetails) {
    return null;
  }

  return (
    <Link
      to="/search"
      className={`mobile-search-tab ${isSearchActive ? 'is-active' : ''}`}
      aria-label="Пошук"
    >
      <img
        src={isSearchActive ? searchIconActive : searchIcon}
        alt=""
      />
    </Link>
  );
};

export default MobileSearchTab;